import { Link, useParams } from "react-router-dom";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal, notification } from "antd";
import axiosInstance from "../../../Services/axiosCommon";
import More from "../../../Components/Icons/More";

import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { NuDate, NuTime } from "../../../Components/Utils/Input";


const { confirm } = Modal;

function ViewMore({ data, getNotes, id }) {
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const {officeId} = useParams();

  const [open, setOpen] = useState(false)
  const handleDelete = async (removevalue, item) => {
    confirm({
      title: `Do you Want to delete ${removevalue}?`,
      centered: true,
      icon: <ExclamationCircleFilled />,
      content: `The ${removevalue} will be removed from the My Diary`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        axiosInstance
          .delete(`/Notes/${item}`)
          .then((res) => {
            getNotes();
          })
          .catch((err) => {
            console.log(err);
          });
      },
      onCancel() {},
    });
  };

    const [createNew, setCreateNew] = useState({
      title: "",
      description: "",
      status: "",
      reminder_date: "",
      reminder_time: "",
      due_date: "",
      files_to_remove:[]
    });



    useEffect(() => {
      data &&
        setCreateNew({
          title: data?.title,
          description: data?.description,
          status: data?.status,
          reminder_date: data?.reminder_date,
          reminder_time: data?.reminder_time,
          due_date: data?.due_date,
        });
  
      
    }, [data]);


    const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: true,
      validationSchema: yup.object({
        title: yup.string().required("Title is Required"),
        status: yup.string().required("Please Select Status"),
      }),
      onSubmit: async (value) => {
        setIsLoading(true);
        let formData = new FormData();
        if (value.reminder_time == "00:00:00") {
          value.reminder_time = "";
        }

        value.files_to_remove = [];
        formData.append("my_notes", JSON.stringify(value));
        formData.append("attachments", []);

       
          axiosInstance
              .put(`/Notes/${data?.notesId}`, formData)
              .then((res) => {
                if (res.status == 201 || res.data.status == true) {
                  setIsLoading(false);
                  api.success({
                    message: `successful`,
                    description: "Remander is successfully set",
                    placement: "bottomRight",
                  });
                  // navigate(-1);
                  getNotes()
                  setOpen(false)
                } else {
                  setIsLoading(false);
                  api.error({
                    message: `Unsuccessfully`,
                    description: "Failed to set remainder",
                    placement: "bottomRight",
                  });
                }
              })
              .catch((err) => {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: "Failed to set remainder",
                  placement: "bottomRight",
                });
              })
         
      },
    });

  return (
    <>
    {contextHolder}
      <div className="text-[#344767]  relative dropdown inline-block z-50">
        <div className=" cursor-pointer underline-offset-8 text-xs mx-auto font-semibold flex items-center">
          <span className="pt-1">
            <span className="pt-1">
              <More />
            </span>
          </span>
        </div>
        <ul className="dropdown-menuOne bg-red-400  text-[#344767] text-left  rounded-lg absolute -left-[80px] -top-1 overflow-hidden hidden  z-50 shadow-lg">
          {/* {NotesEditAccess && ( */}
            <li className=" w-[100px] bg-black block m-0">
              <Link
                className="bg-white hover:bg-gray-100 py-2 text-black hover:text-black px-0.5 block whitespace-no-wrap text-xs font-medium"
                to={`/dairy/edit/${id}`}
                state={{ data: data }}
              >
                Edit
              </Link>
            </li>
          {/* )} */}

         {/* {NotesEditAccess && ( */}
            <li className=" w-[100px] bg-black block m-0">
              <div
                className="bg-white hover:bg-gray-100 py-2 text-black hover:text-black px-0.5 block whitespace-no-wrap text-xs font-medium"
                onClick={()=>setOpen(true)}
              >
                Set Reminder
              </div>
            </li>
          {/* )} */}

          {/* {NotesDeleteAccess && ( */}
            <li className="">
              <span
                className="bg-white hover:bg-gray-100 py-2 px-0.5 text-black cursor-pointer block whitespace-no-wrap text-xs font-medium"
                onClick={() => {
                  handleDelete(data.title, id);
                }}
              >
                Delete
              </span>
            </li>
          {/* )} */}
        </ul>
      </div>
      <Modal
        open={open}
        title={"Set Remainder"}
        width={"25%"}
        className="my-modal"
        centered
        onCancel={() => setOpen(false)}
        footer={[]}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className=" w-full flex flex-wrap">
          <NuDate
                label="Reminder date"
                formik={formik}
                name="reminder_date"
                width=" w-full"
              />
              <NuTime

                disabled={formik.values.reminder_date ? false : true}
                label="Reminder Time "
                de
                formik={formik}
                name="reminder_time"
                width=" w-full"
                min={new Date()}
              />
          <button
              type="submit"
              // htmlType="submit"
              // size="large"
              className="w-11/12 bg-[#048178] py-3 rounded-lg cursor-pointer text-sm outline-none border-none hover:text-white focus:text-white text-white  mx-auto"
            >
              Set Reminder
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default ViewMore;
